module.exports = __webpack_public_path__ + "6232f43d15b0e7a0bf0fe82e295bdd06.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-100italic.woff2
// module id = 657
// module chunks = 0